import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useAuth } from "../AuthContext";
import LottoMarquee from "./LottoMarquee";
import Logo from '../assets/images/egs-logo.png'
import NextDrawingCountdown from "./NextDrawCountdown";
import { footerLinks } from "../constants";

const LottoWidget: React.FC<{ refreshInterval?: number}> = ({ refreshInterval = 10000}) => { 
  const endDate = useRef<Date>();
  let countdownInterval = useRef<any>();
  const potSize = useRef<number>(0);
  const [hasDrawing, setHasDrawing] = useState(true);
  const [millisecondsUntilEnd, setMillisecondsUntilEnd] = useState(0);
  const [timeRemaining, setTimeRemaining] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
  })
  const { backendRequester } = useAuth();
  const ctaLink = window.location.origin;
  
  useEffect(() => {
    if (!millisecondsUntilEnd) {
      return
    }

    const remaining = {
      days: Math.floor(millisecondsUntilEnd / (1000 * 60 * 60 * 24)),
      hours: Math.floor((millisecondsUntilEnd / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((millisecondsUntilEnd / (1000 * 60)) % 60),
    }

    setTimeRemaining({
      days: remaining.days,
      hours: remaining.hours,
      minutes: remaining.minutes,
    })
  }, [millisecondsUntilEnd])

  const ctaText = useMemo(() => hasDrawing ? "play now" : "coming soon", [hasDrawing])

  const getDate = useCallback(async() => {
    try {
      const response = await backendRequester.getCurrentDrawing();
      endDate.current = new Date(response.endDate);
      potSize.current = response.potSize;
      setMillisecondsUntilEnd(new Date(response.endDate).getTime() - new Date().getTime());
      setHasDrawing(true)
    } catch(e) {
      setHasDrawing(false);
      console.error(e);
    }
  }, [backendRequester]);

  useEffect(() => {
    getDate()
    countdownInterval.current = setInterval(() => {
      getDate();
    }, refreshInterval);

    return () => clearInterval(countdownInterval.current);
  }, []);

  return (
  <div className="lotto-widget font-figtree h-full w-full overflow-hidden flex items-center justify-center">
    <div className="py-8 px-4 sm:px-6 text-center relative text-white">
      <div className="text-center w-full relative max-w-[450px]">
          {/* blurcles */}
          <div className="w-96 h-64 rounded-full bg-[#00FFFF] filter blur-3xl absolute left-0 top-0 -z-0 pointer-events-none opacity-20"></div>
          <div className="w-48 h-48 rounded-full bg-[#FF21F8] filter blur-3xl absolute right-0 top-6 -z-0 pointer-events-none opacity-20"></div>
          <div className="epic-logo flex flex-col justify-center">
            <img src={Logo} alt='Epic Gala Sweepstakes' className='w-full max-w-[768px] mx-auto h-auto relative z-0 mb-4' />
          </div>
          <div className="flex justify-center gap-1 text-4xl font-bold z-10 relative">
            <LottoMarquee potSize={potSize.current} />
          </div>
          <NextDrawingCountdown timeRemaining={timeRemaining} />
          <p className="text-white text-sm sm:text-base font-bold">
            Free ticket* with every{' '}
            <span className="text-lottogreen">100 $GALA</span> burn
          </p>
          <p className='text-lottoblue-400 text-super-tiny text-center mb-8'>
            or AMOE option <a className='text-lottoblue-600 underline hover:no-underline' href={footerLinks.terms} target='_blank' rel="noreferrer">Terms and Conditions</a>
          </p>
        </div>
        {
          hasDrawing ? (
            <a href={ctaLink} target="_blank" rel="noopener noreferrer">
              <button className="w-full mx-auto px-20 py-3.5 shadow-lg text-lg font-black lottoCTA-blue whitespace-nowrap uppercase">{ctaText}</button>
            </a>
          ) : 
          <button className="w-full mx-auto px-20 py-3.5 shadow-lg text-lg font-black lottoCTA-blue whitespace-nowrap uppercase">{ctaText}</button>
        }
      </div>
    </div>
  )
}

export default LottoWidget;
